"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VizualizerContainer = exports.SurroundMessage = exports.SurroundContainer = exports.DragSpinContainer = exports.DragMessage = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var VizualizerContainer = _styledComponents["default"].div.withConfig({
  displayName: "VisualizerLiquidPixelstyles__VizualizerContainer",
  componentId: "sc-fvqy9b-0"
})(["text-align:center;width:100%;"]);
exports.VizualizerContainer = VizualizerContainer;
var SurroundContainer = _styledComponents["default"].div.withConfig({
  displayName: "VisualizerLiquidPixelstyles__SurroundContainer",
  componentId: "sc-fvqy9b-1"
})(["width:100%;height:", ";position:relative;overflow:hidden;"], function (props) {
  return props.isMobile ? '250px' : '40.3125rem';
});
exports.SurroundContainer = SurroundContainer;
var SurroundMessage = _styledComponents["default"].div.withConfig({
  displayName: "VisualizerLiquidPixelstyles__SurroundMessage",
  componentId: "sc-fvqy9b-2"
})(["position:relative;"]);
exports.SurroundMessage = SurroundMessage;
var DragSpinContainer = _styledComponents["default"].div.withConfig({
  displayName: "VisualizerLiquidPixelstyles__DragSpinContainer",
  componentId: "sc-fvqy9b-3"
})(["position:absolute;pointer-events:none;z-index:1;top:50%;left:50%;transform:translateX(-50%) translateY(-50%);"]);
exports.DragSpinContainer = DragSpinContainer;
var DragMessage = _styledComponents["default"].p.withConfig({
  displayName: "VisualizerLiquidPixelstyles__DragMessage",
  componentId: "sc-fvqy9b-4"
})(["margin-top:-2px;@media (min-width:768px){margin-top:0;}"]);
exports.DragMessage = DragMessage;
//# sourceMappingURL=VisualizerLiquidPixel.styles.js.map